import axios from 'axios';
import moment from 'moment';
import '../../CSS/Table.css';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { Row, Col, Tag, Spin, Card, List } from 'antd';
import { DonutCounterMock } from '../../../Mock/MockJson';
import { API_DASHBOARD } from '../../../../../commons/api';
import localStorage from '../../../../../utils/localStorage';
import StyledTable from "../../../../../commons/styles/table";
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithSelection, getChartDataWithoutSelection } from '../../ChartCalls';
import {
  trendLabelTranslation,
  predictionsLegendsTranslation
} from '../../../Utils/Adapter/translationAdapter';

const DonutCounter = (props) => {

  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [loading] = useState(false);
  const [, setLinksList] = useState([]);
  const [listDataSource, setListDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState('');
  const [AlertType, setAlertType] = useState('');
  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [selectedAlert, setSelectedAlert] = useState('');

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  let abortController = useRef(new window.AbortController());


  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
    AssetCode
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      _getGenerateData(selectedDevice, AlertType, true, '',"dropdown");
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData();
    _getGenerateData(selectedDevice,AlertType, true, '', 'dropdown');
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    AssetCode,
    props.translationCache
  ]);

  const _getAlertsData = (DeviceCode) => {
    let { AssetCode, graphprops, dashboardName } = props;
    let searchParams = new URLSearchParams(graphprops.apiPayloadData.GETParams);
    let paramObject = Object.fromEntries([...searchParams]);
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const ParameterTypeObject = {
      method: 'POST',
      url: `${API_DASHBOARD.GetAlertsCount}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        AssetCode: AssetCode,
        DeviceCode: DeviceCode,
        SiteId: siteId,
        StartDate: moment().subtract(7, 'day').utc().format('YYYY-MM-DD HH:mm:ss'),
        EndDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        GroupName: dashboardName,
        TimeBucket:graphprops.GraphLevelTimeBucket,
        HierarchyCode: (() => {
          if (graphprops && graphprops.apiPayloadData) {
            if (graphprops.apiPayloadData.method === 'GET') {
              if (paramObject && paramObject.HierarchyCode) {
                return paramObject.HierarchyCode;
              }
            }
            if (graphprops.apiPayloadData.payload && graphprops.apiPayloadData.payload.HierarchyCode) {
              return graphprops.apiPayloadData.payload.HierarchyCode;
            }
          }
          return '';
        })()
      }
    };
    return axios(ParameterTypeObject)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const _getAlertsDetails = (AlertType, DeviceCode) => {
    let { AssetCode, graphprops, dashboardName } = props;

    let searchParams = new URLSearchParams(graphprops.apiPayloadData.GETParams);
    let paramObject = Object.fromEntries([...searchParams]);
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const ParameterTypeObject = {
      method: 'POST',
      url: `${API_DASHBOARD.GetAlertsData}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        AssetCode: AssetCode,
        DeviceCode: DeviceCode,
        // DeviceType: this.props.DeviceCode,
        SiteId: siteId,
        StartDate: moment().subtract(7, 'day').utc().format('YYYY-MM-DD HH:mm:ss'),
        EndDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        Type: AlertType || 'All',
        GroupName: dashboardName,
        TimeBucket:graphprops.GraphLevelTimeBucket,
        HierarchyCode: (() => {
          if (graphprops && graphprops.apiPayloadData) {
            if (graphprops.apiPayloadData.method === 'GET') {
              if (paramObject && paramObject.HierarchyCode) {
                return paramObject.HierarchyCode;
              }
            }
            if (graphprops.apiPayloadData.payload && graphprops.apiPayloadData.payload.HierarchyCode) {
              return graphprops.apiPayloadData.payload.HierarchyCode;
            }
          }
          return '';
        })()
      }
    };
    return axios(ParameterTypeObject)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const _getGenerateData = async (selectedDevice, AlertType, status, selectedDeviceName) => {
    let { graphprops } = props;
    selectedDevice =
      selectedDevice && selectedDevice === '' ? selectedDevice : props.DeviceCode;
    if (status) {
      let listDataSource = await _getAlertsData(selectedDevice);
      setListDataSource(listDataSource);
    }
    let dataSource = await _getAlertsDetails(AlertType, selectedDevice);
    let columnsString = graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].columns
  ? graphprops[graphprops.graph].columns
  : '[]';
    let columnsData = JSON.parse(columnsString);
     
    let columnsValue =
      columnsData &&
      columnsData.map((data) => {
        return {
          ...data,
          ...(data.sort && data.sort === false
            ? { sorter: (a, b) => a[data].length - b[data].length }
            : {}),
          ...(data.isUTC && data.isUTC === false
            ? {
              render: (text) => {
                return {
                  children: <div>{moment(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
                };
              }
            }
            : data.isUTC && data.isUTC === true
              ? {
                render: (text) => {
                  return {
                    children: <div>{moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss')}</div>
                  };
                }
              }
              : {})
        };
      });
    let linksList =
      graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].links
        ? JSON.parse(graphprops[graphprops.graph].links)
        : [];
    setColumns(columnsValue);
    setDataSource(dataSource);
    setSelectedDevice(selectedDevice);
    setAlertType(AlertType);
    setSelectedAlert(status === false ? AlertType : '');
    setSelectedDeviceName(selectedDeviceName);
    setLinksList(linksList);
  };

  const onChartClick = async (cellData) => {
    if (cellData.componentSubType === 'pie') {
      await _getGenerateData(
        cellData.data.description,
        AlertType,
        true,
        cellData.name
      );
      setSelectedAlert('');
    } else if (cellData.componentType === 'title') {
      await _getGenerateData('', AlertType, true, cellData.name);
      setSelectedAlert('');
      let listDataSource = await _getAlertsData(selectedDevice);
      setListDataSource(listDataSource);
    }
  };

  const onEvents = {
    click: (cellData) => onChartClick(cellData)
  };

  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = DonutCounterMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
            AssetCode:AssetCode
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
            AssetCode:AssetCode
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      const clonedOption = cloneDeep(option);
      let legend = {
        left: '55%',
        top: '10%',
        orient: 'vertical',
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontSize: 18,
          fontWeight: 'bold',
          top: '61%'
        },
        data:
          json && Array.isArray(json)
            ? json.map((data) => {
              return data.Name;
            })
            : []
      };
      let series = [];
      let total = 0;
      if (json && Array.isArray(json)) {
        series = json.map((val) => {
          total = total + val.Value;
          return { value: val.Value, name: val.Name, description: val.Description };
        });
      }

      let title = {
        text: `Total`,
        triggerEvent: true,
        subtext: `${total}`,
        left: '30%',
        top: 'center',
        textStyle: {
          color: 'white'
        },
        subtextStyle: {
          fontSize: 20,
          color: 'white',
          left: '20%'
        },
        textAlign: 'center'
      };
      if (
        props.graphprops.colors !== null &&
        props.graphprops.colors !== undefined &&
        props.graphprops.colors.length !== 0
      ) {
        clonedOption.color = [...props.graphprops.colors];
      }
      series = await trendLabelTranslation(series, props.translationCache);
      let legends = await predictionsLegendsTranslation(legend, props.translationCache);
      clonedOption.title = title;
      clonedOption.legend = legends;
      clonedOption.series[0].data = [...series];
      setOption(clonedOption);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  function getOption() {
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}'
      },
      legend: {
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontSize: 18,
          fontWeight: 'bold'
        },
        type: 'scroll',
        orient: 'vertical',
        right: '50%',
        top: 0,
        bottom: 20,
        data: []
      },

      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          name: props.graphprops.title,
          type: 'pie',
          radius: ['40%', '68%'],
          center: ['30%', '35%'],
          height: '500px',
          color: [
            '#f70505',
            '#e0f70f',
            '#e09722',
            '#22c7ab',
            '#1E5128',
            '#52057B',
            '#082296',
            '#c0a0f2',
            '#cc16f5',
            '#5f85db',
            '#C62A88',
            '#00A8CC'
          ],
          avoidLabelOverlap: false,
          data: [],
          label: {
            show: true,
            position: 'inner',
            formatter: '{c}'
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };

    return option;
  }

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <>
          {loading === false ? (
            <div style={{ padding: '0px' }}>
              <Row>
                <Col span={22}>
                  {noDataInDB === true || errorInAPI === true ? (
                    noDataInDB === true ? (
                      <NoRecordComponent />
                    ) : (
                      <ErrorComponent />
                    )
                  ) : (
                    <ReactEcharts
                      option={option}
                      className="react_for_echarts"
                      style={{ height: '360px', width: '100%' }}
                      onEvents={onEvents}
                    />
                  )}
                </Col>
                <Col span={2}>
                  {listDataSource &&
                    Array.isArray(listDataSource) &&
                    listDataSource.length > 0 ? (
                    <List
                      grid={{
                        gutter: 5,
                        column: 1
                      }}
                      dataSource={listDataSource}
                      style={{
                        textAlign: 'center',
                        textColor: '#fff !important'
                      }}
                      header={
                        <div style={{ color: 'white', fontWeight: 'bold' }}>
                          {selectedDeviceName ? selectedDeviceName : 'All Devices'}
                        </div>
                      }
                      renderItem={(item) => (
                        <List.Item>
                          <Card
                            className="counterCard"
                            title={item.Name}
                            style={{
                              backgroundColor:
                                selectedAlert === item.Name ? '#7bbcf2' : 'steelblue',
                              cursor: 'pointer'
                            }}
                          >
                            <div
                              onClick={() =>
                                _getGenerateData(
                                  selectedDevice,
                                  item.Name,
                                  false,
                                  selectedDeviceName
                                )
                              }
                            >
                              {item.Value}
                            </div>
                          </Card>
                        </List.Item>
                      )}
                    />
                  ) : null}
                </Col>
                <Col span={24}>

                  <div style={{ marginTop: '50px' }}>
                    {columns && Array.isArray(columns) && columns.length > 0 ? (
                      <StyledTable size="small"
                        showSorterTooltip={false}
                        columns={columns && Array.isArray(columns) ? columns : []}
                        dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
                        pagination={{ pageSize: '5' }}
                      />
                    ) : null}
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
           <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
          )}
        </>
      )}
    </Fragment>
  );
};


const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(DonutCounter);
